import type { estypes } from '@elastic/elasticsearch'

import { commonMapping, textSubtypes } from './utils'

export const notesMapping = {
  ...commonMapping,
  contentVectorE5: {
    type: 'dense_vector',
    dims: 1024,
    index: true,
    similarity: 'cosine',
  },
  contentVectorBGE: {
    type: 'dense_vector',
    dims: 1024,
    index: true,
    similarity: 'cosine',
  },
  content_embedding: {
    properties: {
      predicted_value: {
        type: 'dense_vector',
        dims: 768,
        index: true,
        similarity: 'cosine',
      },
    },
  },
  content: {
    type: 'text',
    ...textSubtypes,
  },
} satisfies Record<string, estypes.MappingProperty>
